export default __webpack_public_path__ + "static/media/testImg.65b96e3d.svg";